import { LoginForm } from '@/components/auth/LoginForm';

export function Login() {
  return (
    <div className="flex items-center justify-center min-h-[70vh] px-4">
      <LoginForm />
    </div>
  );
}